// eslint-disable no-console
import { DEBUG_LOGGERS } from './env'
import * as Sentry from '@sentry/react'
import type { ParameterizedString } from '@sentry/core'

export const fmt = Sentry.logger.fmt

interface StructuredLogger {
    readonly debug: typeof Sentry.logger.debug

    readonly info: typeof Sentry.logger.info

    readonly warn: typeof Sentry.logger.warn

    readonly error: typeof Sentry.logger.error

    readonly fatal: typeof Sentry.logger.fatal
    isDebug: boolean
}

const LOGGERS: Partial<Record<string, StructuredLogger>> = {}

function formatParameterizedString(ps: ParameterizedString): string {
  // 如果已经是纯字符串，直接返回
  if (typeof ps === 'string') {
    return ps;
  }

  // 获取模板和值（优先使用标记属性，fallback 到 message/params）
  const template = (ps as any).__sentry_template_string__ || (ps as any).message || '';
  const values = (ps as any).__sentry_template_values__ || (ps as any).params || [];

  // 逐个替换 %s 占位符（位置性替换）
  let result = template;
  let index = 0;
  result = result.replace(/%s/g, () => {
    const value = values[index++];
    return value !== undefined ? String(value) : '%s'; // 如果参数不足，保留 %s
  });

  return result;
}

export function logger(name: string): StructuredLogger {
  if (LOGGERS[name]) {
    return LOGGERS[name]
  }

  const logger: StructuredLogger = {
    isDebug: DEBUG_LOGGERS.includes(name),
    debug(message, attributes, cap) {
      if (this.isDebug) {
        Sentry.logger.debug(message, attributes, cap)
        let formatted = `[D][${name}] ${formatParameterizedString(message)}`;
        console.debug(formatted)
      }
    },
    info: (message, attributes, cap) => {
      Sentry.logger.info(message, attributes, cap)
      let formatted = `[I][${name}] ${formatParameterizedString(message)}`;
      console.info(formatted)
    },
    warn: (message, attributes, cap) => {
      Sentry.logger.warn(message, attributes, cap)
      let formatted = `[W][${name}] ${formatParameterizedString(message)}`;
      console.warn(formatted)
    },
    error: (message, attributes, cap) => {
      Sentry.logger.error(message, attributes, cap)
      let formatted = `[E][${name}] ${formatParameterizedString(message)}`;
      console.error(formatted)
    },
    fatal: (message, attributes, cap) => {
      Sentry.logger.fatal(message, attributes, cap)
      let formatted = `[F][${name}] ${formatParameterizedString(message)}`;
      console.error(formatted)
    }
  }

  LOGGERS[name] = logger

  return logger
}

export function listLoggers() {
  return Object.keys(LOGGERS)
}
